class Dialog {
  private el: HTMLElement;
  private closeButton: HTMLElement;
  private isOpen: boolean = false;

  constructor(element: HTMLElement) {
    this.el = element;
    this.closeButton = (this as any).el.querySelector('[data-close]');
    (this as any).el.onClose = this.close.bind(this);
    (this as any).el.onOpen = this.close.bind(this);
    this.addEvents();
  }

  private addEvents() {
    (window as any).emitter.on(
      `open-dialog-${(this as any).el.dataset.id}`,
      () => {
        this.open();
      },
    );

    window.addEventListener('keydown', (e: any) => {
      if ((e.code === 'Escape' || e.key === 'Escape') && this.isOpen) {
        this.close();
      }
    });

    this.el.addEventListener('click', (e: any) => {
      if (e.target.closest('.dialog__close')) {
        this.close();
      }
    });
  }

  private open() {
    let sliders: any[] = Array.from(
      this.el.querySelectorAll('[data-ref="slider"]'),
    );
    let form: any = this.el.querySelector('form');
    (this as any).el.classList.add('open');
    document.body.classList.add('overflow-hidden');
    this.isOpen = true;

    if (sliders.length) {
      sliders.forEach((slider) => {
        slider.swiper.update();
      });
    }
  }

  private close() {
    let flashMessage = (this as any).el.querySelector('.flashMessage.visible');
    if (flashMessage) {
      flashMessage.classList.remove('visible');
    }
    (this as any).el.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
    (window as any).emitter.emit(`close-dialog-${(this as any).el.dataset.id}`);
    this.isOpen = false;
  }
}

export default Dialog;
